import { useDemoData } from './useDemoData'
import { useSiteFilters } from './useSiteFilters'
import uniq from 'lodash/uniq'
import get from 'lodash/get'

import { CategoryFilterKey, CATEGORY_FILTERS } from '../types'

type FilterOptions = Record<CategoryFilterKey, string[]>

const getFilterOptions = (sites: unknown[] | undefined = []): FilterOptions => {
    return CATEGORY_FILTERS.reduce((acc: FilterOptions, key: string) => {
        const values = uniq(sites.map((site) => get(site, key)).filter(Boolean)).sort()
        return { ...acc, [key]: values }
    }, {} as FilterOptions)
}

export const useDemoSites = () => {
    const query = useDemoData()
    const filterMethods = useSiteFilters()
    const filterOptions = getFilterOptions(query.data)

    return {
        ...query,
        filterMethods,
        filterOptions,
    }
}
